import { subscriptionStatuses, SubscriptionStatusesTypes } from './constants';

export const getPlanListStatusIndicators = (
  status?: SubscriptionStatusesTypes
) => {
  const showStatus =
    status === subscriptionStatuses.PENDING ||
    status === subscriptionStatuses.PAUSED ||
    status === subscriptionStatuses.CANCELLED;
  const isPending = status === subscriptionStatuses.PENDING;

  return { showStatus, isPending };
};
